import React from 'react';
// import { Table } from 'evergreen-ui';
import Table from 'react-bootstrap/Table';


function fixedFloat(nbr, toFixed = 2) {
  return parseFloat(nbr.toFixed(toFixed));
}

// a / {[(1 + i) ^n] - 1} / [i(1 + i)^n]
// ia / [1 − (1+i)^-n]
function calculateRepaymentAmount(a, n, i) {
  // return a / (((1 + i) ** n - 1) / (i * (1 + i) ** n));
  return (i * a) / (1 - (1 + i) ** -n);
}

function Amortization(props) {
  const { loanAmount, remainingTerm, interestRate } = props.store;

  if (!loanAmount || !remainingTerm || !interestRate) {
    return null;
  }

  const rows = Math.ceil(remainingTerm * 12);
  const repaymentAmount = fixedFloat(
    calculateRepaymentAmount(
      loanAmount,
      remainingTerm * 12,
      interestRate / 100 / 12
    )
  );

  let balance = loanAmount;

  const data = [];
  [...new Array(rows)].forEach((_,i)=>{
    const interest = fixedFloat((balance * interestRate) / 100 / 12);
    const principal = fixedFloat(repaymentAmount - interest);
    balance = fixedFloat(balance - principal);
    if (i < 5 || i > rows - 3) {
      data.push({
        sr: i+1,
        interest: interest,
        principal: principal,
        balance: balance,
        repaymentAmount: repaymentAmount
      })
    } else if (i === 5) {
      data.push({
        sr: '...',
        interest: '...',
        principal: '...',
        balance: '...',
        repaymentAmount: '...',
      })
    }
  })

  return (
    <Table striped bordered hover responsive size="sm" style={{marginTop: '20px'}}>
      <thead>
        <tr>
          <th>Payment #</th>
          {/* <th>Previous</th> */}
          <th>Balance</th>
          <th>Monthly Repayment</th>
          <th>Principal</th>
          <th>Interest</th>
        </tr>
      </thead>
      <tbody>
        {!isNaN(rows) &&
          data.map((r, index) => {
            return (
              <tr key={r.sr}>
                <td>{r.sr}</td>
                {/* <td>{prev}</td> */}
                <td>{r.balance}</td>
                <td>{r.repaymentAmount}</td>
                <td>{r.principal}</td>
                <td>{r.interest}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
}

export default Amortization;